import {
  BaseStore,
} from '../types';

export class BaseUIStore extends BaseStore {

}
